import React from 'react';
import { useSettings } from '../contexts/SettingsContext';

const Checkbox = ({
  label,
  checked = false,
  onChange,
  name,
  disabled = false,
  className = '',
}) => {
  const { settings } = useSettings();
  const primaryColor = settings.theme?.colors?.primary || '#3B5BDB';

  return (
    <label
      className={`flex items-center cursor-pointer transition-colors duration-250 ${disabled ? 'opacity-60 cursor-not-allowed' : ''} ${className}`}
    >
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="peer hidden"
      />
      <div
        className="w-4 h-4 rounded border border-gray-300 dark:border-gray-600 flex items-center justify-center transition-colors duration-250
          peer-checked:bg-gradient-to-b peer-checked:from-[#3B5BDB] peer-checked:to-[#20C997] peer-checked:border-none
          [&>svg]:hidden peer-checked:[&>svg]:block"
        style={{ minWidth: 16, minHeight: 16 }}
      >
        <svg
          className="w-3 h-3 text-white"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      {label && (
        <span className="ml-2 text-sm text-gray-600 dark:text-gray-400 transition-colors duration-250">
          {label}
        </span>
      )}
    </label>
  );
};

export default Checkbox;
